const config = {
  inputFields: {
    spendDetailsRow: [
      {
        placeholder: "Facility name",
        label: "Facility Name",
        type: "text",
      },
      {
        placeholder: "Total SKUs",
        defaultValue: "0",
        label: "Total SKUs",
        displayLabel: "Total SKUs Managed by PAR",
        type: "number",
        errors: {
          scaleCountError: "Must be equal or greater than total scales",
        },
      },
      {
        placeholder: "Scale Count",
        defaultValue: "0",
        type: "number",
        label: "Scale Count",
        displayLabel: "Total PAR Scales to Deploy",
      },
      {
        placeholder: "Total locations under management",
        defaultValue: "0",
        type: "number",
        label: "Inventory Locations Under Management (all departments)",
        displayLabel: "Locations Under Management (all depts)",
      },
      {
        defaultValue: "0",
        label: "Inventory Count Frequency per Week",
        displayLabel: "Avg. Order Days per Week (per location)",
        type: "number",
        smallNote: "Typically 5; how many days/week each location is counted (max 7).",
      },
      {
        placeholder: "Per location",
        defaultValue: "0",
        type: "number",
        label: "Estimated Monthly Call Downs",
        displayLabel: "Est. Avg. Daily Call Downs",
      },
      {
        placeholder: "Response time in minutes",
        defaultValue: "0",
        type: "number",
        label: "Call Down Response Time",
        displayLabel: "Call Down Response Time (min.)",
        suffix: " min",
      },
      {
        placeholder: "Annual Medsurg supply spend",
        defaultValue: "0",
        type: "number",
        prefix: "$",
        label: "Annual Medsurg Spend",
        displayLabel: "Annual Medsurg Supply Spend to be Managed by PAR",
      },
      {
        placeholder: "Annual direct purchase spend",
        defaultValue: "0",
        type: "number",
        prefix: "$",
        label: "Annual Direct Purchase Spend",
        displayLabel: "Annual Direct Purchase Spend to be Managed by PAR",
      },
      {
        placeholder: "Annual Bill-Only Spend",
        defaultValue: "0",
        type: "number",
        prefix: "$",
        label: "Annual Bill Only Spend",
        displayLabel: "Annual Bill-Only Spend to be Managed by PAR",
      },
      {
        placeholder: "Lines Picked per Month",
        defaultValue: "0",
        type: "number",
        label: "Lines Picked per Month",
        displayLabel: "PO Lines Received per Month",
      },
      {
        defaultValue: "0",
        label: "Current Monthly Inventory System Fees",
        displayLabel: "Monthly Inventory System Fees",
        type: "number",
        prefix: "$",
      },
      {
        label: "Est. Cost of Annual Inventory",
        displayLabel: "Est. Annual Inventory Cost",
        defaultValue: "0",
        type: "number",
        prefix: "$",
      },
    ],
    clientCosts: [
      {
        label: "Avg SKU Coverage Per Hour",
        displayLabel: "Avg. SKU Coverage per Hour *",
        placeholder: "SKUs per hour",
        defaultValue: "0",
        type: "number",
        smallNote: "* Typically 600 SKUs/hr.; include travel time, interruptions, etc.",
      },
      {
        label: "Estimated Average Annual Supply Cost Increase",
        displayLabel: "Estimated Average Annual Supply Cost Increase (#1)",
        placeholder: "Annual increase (%)",
        defaultValue: "0",
        type: "number",
        suffix: "%",
      },
      {
        label: "Cost per Pick/Line",
        defaultValue: "0",
        type: "number",
        prefix: "$",
      },
      {
        label: "Product Expiration Rate",
        displayLabel: "Est. Product Expiration Rate (#2)",
        placeholder: "Product Expiration Rate",
        defaultValue: "0",
        type: "number",
        suffix: "%",
      },
      {
        label: "Overstock",
        displayLabel: "Est. Avg. Supplies Overstock Percentage (#3)",
        placeholder: "Overstock",
        defaultValue: "0",
        suffix: "%",
        type: "number",
      },
      {
        label: "Cost of Capital",
        displayLabel: "Client's Cost of Capital *",
        placeholder: "Cost of capital (%)",
        defaultValue: "0",
        suffix: "%",
        type: "number",
        smallNote: "* Typically 10-12%.",
      },
      {
        label: "Estimated Annual Inventory Turns - Patient Care Locations",
        displayLabel: "Estimated Annual Inventory Turns - Patient Care Locations (#)",
        placeholder: "Turns per year",
        defaultValue: "0",
        type: "number",
        smallNote: "(Typically 3-6 turns per year).",
      },
      {
        label: "Estimated Annual Inventory Turns - Procedural Care Locations",
        displayLabel: "Estimated Annual Inventory Turns - Procedural Care Locations (#)",
        placeholder: "Turns per year",
        defaultValue: "0",
        type: "number",
        smallNote: "(Typically 2-5 turns per year).",
      },
    ],
    laborCost: [
      {
        customText: "Inventory Tech",
        hiddenLabel: true,
        disabled: true,
      },
      {
        placeholder: "amount",
        header: "Hourly Rate",
        name: "Inventory Tech",
        defaultValue: "0",
        hiddenLabel: true,
        type: "number",
        prefix: "$",
      },
      {
        placeholder: "amount",
        name: "Inventory Tech",
        header: "Benefits",
        defaultValue: "0",
        hiddenLabel: true,
        type: "number",
        suffix: "%",
      },
      { customText: "Lead" },
      {
        placeholder: "amount",
        header: "Hourly Rate",
        name: "Lead",
        defaultValue: "0",
        hiddenLabel: true,
        type: "number",
        prefix: "$",
      },
      {
        placeholder: "amount",
        name: "Lead",
        defaultValue: "0",
        header: "Benefits",
        hiddenLabel: true,
        type: "number",
        suffix: "%",
        disabled: true,
      },
      { customText: "Supervisor" },
      {
        placeholder: "amount",
        header: "Hourly Rate",
        name: "Supervisor",
        defaultValue: "0",
        hiddenLabel: true,
        type: "number",
        prefix: "$",
      },
      {
        placeholder: "amount",
        defaultValue: "0",
        header: "Benefits",
        name: "Supervisor",
        hiddenLabel: true,
        type: "number",
        suffix: "%",
        disabled: true,
      },
    ],
    investmentSummary: [
      {
        customText: "Scale Hardware (CAPEX)",
        displayText: "Scale hardware (CAPEX) — Year 1 only",
        type: "number",
        prefix: "$",
        hiddenLabel: true,
        defaultValue: "0",
        includeInUpfrontTotal: true,
      },
      {
        customText: "Implementation Fee",
        displayText: "Implementation Fees (combined, all facilities)",
        type: "number",
        prefix: "$",
        hiddenLabel: true,
        defaultValue: "0",
        includeInUpfrontTotal: true,
      },
      {
        customText: "Project Management Fee",
        displayText: "Project Management Fees (combined, all facilities)",
        type: "number",
        prefix: "$",
        hiddenLabel: true,
        defaultValue: "0",
        includeInUpfrontTotal: true,
      },
      {
        customText: "Other fees or direct costs",
        displayText: "Other fees or direct costs (combined, all facilities)",
        type: "number",
        prefix: "$",
        hiddenLabel: true,
        defaultValue: "0",
        includeInUpfrontTotal: true,
      },
      {
        customText: "Annual Recurring Support Fees (est.)",
        type: "number",
        prefix: "$",
        hiddenLabel: true,
        defaultValue: "0",
        disabled: true,
      },
    ],
  },
};

export const useConfig = () => {
  return config;
};
